import { Key } from "react"

import {
  selectDepositsWithWithdrawalStatus,
  useDappSelector,
} from "#/redux-state"
import WbtcTbtcMigrationStatusBanners from "#/ui-old/Banners/WbtcTbtcMigrationStatusBanners"

import DepositEmptyState from "./DepositEmptyState"
import DepositList from "./DepositList"

type DepositListDashboardProps = {
  onChangeTab: (key: Key) => void
}

export default function DepositListDashboard({
  onChangeTab,
}: DepositListDashboardProps) {
  const deposits = useDappSelector(selectDepositsWithWithdrawalStatus)

  if (!deposits.length) return <DepositEmptyState onClick={onChangeTab} />

  return (
    <>
      <WbtcTbtcMigrationStatusBanners />
      <DepositList setActiveTab={onChangeTab} />
    </>
  )
}
